import DeviceManager, { OnPromiseAttrType } from '../utils/device-manager';

/**
 * Usage:
 * Add the class "full-height" to your element and optionally add theses attributes:
 *     - full-height-min    (bool: 0/1) to add min-height rather height style (default: 0).
 * 
 * <div class="my-element full-height" full-height-min="0"></div>
 */
const FullHeight = {
    init() : void {
        document.querySelectorAll('.full-height').forEach($item => {
            DeviceManager.addWindowCallback(this.onResize, $item);
        });
    },

    onResize(attr: OnPromiseAttrType, $item: HTMLElement) : void {
        const heightProperty = '1' === $item.getAttribute('full-height-min') ? 'min-height' : 'height';

        if (DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) { // Large device
            const $stickyBar = document.querySelector('.sticky-bar');
            let stickyBarHeight = 0;

            if ($stickyBar && 'none' !== window.getComputedStyle($stickyBar).display) {
                stickyBarHeight = $stickyBar.clientHeight;
            }

            // @ts-expect-error heightProperty contains only authorized string but typescript do not recognized it
            $item.style[heightProperty] = `calc(100vh - ${stickyBarHeight}px)`;
        } else { // Small device
            // @ts-expect-error heightProperty contains only authorized string but typescript do not recognized it
            $item.style[heightProperty] = '';
        }
    },
};

export default FullHeight;
